class HallowayGalleryVideo extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.frame = requestAnimationFrame(() => this.initialize());
  }

  initialize() {
    if (!this.isConnected) return;
    const { signal } = this.controller;
    const video = this.querySelector('video');
    const button = this.querySelector('[data-hw-play-video]');
    const error = this.querySelector('[data-hw-video-error]');
    if (!video || !button || !error) return;
    this.dataset.hwVideoReady = 'true';
    this.video = video;
    const fail = () => {
      this.removeAttribute('aria-busy');
      button.disabled = false;
      button.hidden = false;
      video.controls = false;
      error.hidden = false;
    };
    button.addEventListener('click', event => {
      event.stopPropagation();
      error.hidden = true;
      button.disabled = true;
      this.setAttribute('aria-busy', 'true');
      video.controls = true;
      if (!video.hasAttribute('src')) video.src = video.dataset.hwVideoSource;
      if (video.error) video.load();
      video.play().catch(reason => {
        if (reason.name === 'AbortError') {
          this.removeAttribute('aria-busy');
          button.disabled = false;
        } else fail();
      });
    }, { signal });
    video.addEventListener('playing', () => {
      this.removeAttribute('aria-busy');
      button.disabled = false;
      button.hidden = true;
      error.hidden = true;
    }, { signal });
    video.addEventListener('error', fail, { signal });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) video.pause();
    }, { signal });
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) video.pause();
      }, { threshold: 0.05 });
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.controller?.abort();
    this.observer?.disconnect();
    if (this.video) {
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
    }
  }
}
if (!customElements.get('hw-gallery-video')) customElements.define('hw-gallery-video', HallowayGalleryVideo);
